<div class="pt-4">
  <p class="mb-3 mt-5 font-accent text-md font-bold md:mt-6">
    {{ title }}
    <span *ngIf="required">&#42;</span>
  </p>

  <app-block-list
    [blockIdList]="options"
    [injectData]="{ parentId: blockId }"
  ></app-block-list>
</div>
